module.exports = __webpack_public_path__ + "static/media/p4.4f374a7e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/p4.webp
// module id = 272
// module chunks = 0